import { createContext, useContext } from 'react';

export type ChartScheme = 'light' | 'dark';

export const ChartSchemeContext = createContext<ChartScheme>('light');

export function useChartScheme(): ChartScheme {
  return useContext(ChartSchemeContext);
}
